import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';
import { string } from 'prop-types';
import variables from '../../styles/variables.module.scss';

import favIcon16 from '../../../static/favicon/favicon-16x16.png';
import favIcon32 from '../../../static/favicon/favicon-32x32.png';
import favIconAppleTouch from '../../../static/favicon/apple-touch-icon.png';
import safariPinnedTabIcon from '../../../static/favicon/safari-pinned-tab.svg';
import socialBanner from '../../assets/images/metaImage.jpg';

const Head = ({ pathname }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  const frontPageTitle = 'We App | Your tech partner';

  const getTitle = () => {
    if (pathname === '/' || !pathname) {
      return frontPageTitle;
    }
    let pageTitle = '';
    const arr = pathname.replace('/', '').split('/');
    arr.forEach((word, index) => {
      pageTitle += word.substr(0, 1).toUpperCase() + word.substr(1);
      if (index !== arr.length - 1) pageTitle += ' - ';
    });
    return `${data.site.siteMetadata.title} | ${pageTitle}`;
  };

  const metaDescription = 'We are developers. We are entrepreneurs. And together we will make your dream a reality.';

  return (
    <Helmet
      title={getTitle()}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          name: 'msapplication-TileColor',
          content: variables.carbonBlack,
        },
        {
          name: 'theme-color',
          content: variables.carbonBlack,
        },
        {
          name: 'keywords',
          content: 'apputvecklare, react, react native',
        },
        {
          name: 'image',
          content: socialBanner,
        },
        {
          property: 'og:url',
          content: 'https://www.weapp.se',
        },
        {
          property: 'og:title',
          content: 'We App',
        },
        {
          property: 'og:description',
          content: 'We work with fast moving startups and medium-sized companies to help them launch and grow the next generation of tech-driven business.',
        },
        {
          property: 'og:image',
          content: socialBanner,
        },
      ]}
      link={[
        {
          rel: 'icon', type: 'image/png', sizes: '16x16', href: `${favIcon16}`,
        },
        {
          rel: 'icon', type: 'image/png', sizes: '32x32', href: `${favIcon32}`,
        },
        {
          rel: 'apple-touch-icon', type: 'image/png', sizes: '180x180', href: `${favIconAppleTouch}`,
        },
        {
          rel: 'mask-icon', href: `${safariPinnedTabIcon}`, color: variables.springGreen,
        },
      ]}
    />
  );
};

Head.propTypes = {
  pathname: string,
};

Head.defaultProps = {
  pathname: '',
};

export default Head;
